const log = (...msg) => console.log('[Accessibility]', ...msg);
const rootCart = '.icart .icart-main .icart-inner';
const rootReviews = '.yotpo.yotpo-main-widget';

function mainAccessibility () {
  const liveMsgId = 'accessibility-live-message';
  const el = (selector) => document.querySelector(selector);
  const focus = (selector) => el(selector).focus();
  const htmlGet = (selector) => el(selector).innerHTML;
  const attrSet = (selector, attr, value) => el(selector).setAttribute(attr, value);

  log('main()');

  function pollFor (selector, cb, pollTime = 0) {
    let elements = document.querySelectorAll(selector);

    // execute callback if elements found
    if (elements.length) return cb(elements);

    // timeout after 30 seconds
    if (pollTime >= 30e3) return false;

    // keep searching if not found
    let nextIteration = pollFor.bind(null, selector, cb, pollTime + 50);
    setTimeout(nextIteration, 50);
  }

  function sendLiveMessage (msg, delay = 0) {
    log('sendLiveMessage:', { delay, msg });

    setTimeout(() => el(`#${liveMsgId}`).innerHTML = msg, 1e3 * delay);
  }

  pollFor(rootCart, () => {
    function generate () {
      log('generate()');

      function payments () {
        log('generate()', 'payments()');
        let paymentButton = '.kqsiVA9Jf8LJAbxw8Bau';

        pollFor(paymentButton, () => {
          document.querySelectorAll(paymentButton).forEach(e => {
            const button = e;
            const title = button.querySelector('.Xrk_DudB6JJ3t2Kh2_cU');
            let label = title ? title.textContent.trim() : null;

            if (label && !label.includes('Buy now with')) {
              label = `Buy now with ${label}`;
            }

            log({ button, label });

            button.querySelectorAll('*').forEach(e => {
              e.setAttribute('aria-hidden', true);
            });

            button.setAttribute('aria-label', label);
          });

          document.querySelectorAll('.shopify-payment-button__more-options').forEach(e => {
            const button = e;

            log({ button });
            button.setAttribute('aria-label', 'View more payment options');
          });
        });
      }

      function overlay () {
        setTimeout(() => {
          attrSet('#attentive_overlay', 'role', 'dialog');
        }, 5e3);
      }

      function cartMenu () {
        attrSet(rootCart, 'role', 'dialog');
        attrSet(rootCart, 'aria-modal', 'true');
        attrSet(rootCart, 'aria-hidden', true);
        // attrSet(rootCart, 'aria-selected', false);
        attrSet(rootCart, 'aria-labelledby', 'cart_label');
        attrSet(rootCart, 'aria-describedby', 'cart_desc');
      }

      function liveMessage () {
        log('generate()', 'liveMessage()');

        const msg = document.createElement('span');
        msg.setAttribute('aria-live', 'polite');
        msg.setAttribute('role', 'status');
        msg.id = liveMsgId;
        msg.style.top = '-100%';
        msg.style.left = '-100%';
        msg.style.fontSize = 0;
        msg.style.position = 'fixed';
        document.body.append(msg);
      }

      overlay();
      cartMenu();
      liveMessage();
      payments();
    }

    function events () {
      log('events()');

      function addToCart () {
        log('events()', 'addToCart()');

        window.addEventListener('icartAddToCartEvent', () => {
          sendLiveMessage('New Product Added to Cart', 1);
        });
      }

      function cartMenu () {
        function constructor () {
          const cartQty = htmlGet('#cart-icon-bubble .cart-count-bubble');

          // Cart Button
          attrSet('#cart-icon-bubble', 'aria-label', `Cart content: ${cartQty}`);

          // Title
          attrSet(`${rootCart} .icart-header-title`, 'id', 'cart_label');
          attrSet(`${rootCart} .icart-justadded`, 'id', 'cart_desc');

          // Button Close
          attrSet(`${rootCart} .icart-close-btn`, 'aria-label', 'Close shopping cart');
        }

        const target = document.querySelector(rootCart);
        const config = { attributes: true, attributeFilter: ['class'], childList: false, subtree: false };

        const action = (mutationList) => {
          const mutation = mutationList[0];
          const isActive = target.classList.contains('active');

          constructor();

          attrSet('#shopify-section-header', 'aria-hidden', isActive);
          attrSet('#MainContent', 'aria-hidden', isActive);
          attrSet('#attentive_overlay', 'aria-hidden', isActive);
          attrSet(rootCart, 'aria-hidden', !isActive);

          attrSet('#shopify-section-header', 'tabindex', isActive ? -1 : 0);
          attrSet('#MainContent', 'tabindex', isActive ? -1 : 0);
          attrSet('#attentive_overlay', 'tabindex', isActive ? -1 : 0);
          attrSet(rootCart, 'tabindex', isActive ? 0 : -1);

          // attrSet(rootCart, 'aria-selected', isActive);
          log(isActive, mutation);

          if (isActive) {
            setTimeout(() => {
              focus(rootCart);
            }, 1e3);
          }
        };

        new MutationObserver(action).observe(target, config);
      }

      addToCart();
      cartMenu();
    }

    generate();
    events();
  });

  pollFor(`${rootReviews} .yotpo-nav-content`, (element) => {
    const target = document.querySelector(rootReviews);
    log(target, rootCart);

    function action () {
      const names = document.querySelectorAll(`${rootReviews} .y-label.yotpo-user-name`);
      const verifiedBuyers = document.querySelectorAll(`${rootReviews} .label-with-tooltip`);
      const navigation = document.querySelectorAll(`${rootReviews} .yotpo-nav-content nav`);

      log('Run Action', {
        names,
        verifiedBuyers,
        navigation
      });


      names.forEach(e => {
        e.setAttribute('role', 'heading');
      });

      verifiedBuyers.forEach(e => {
        const text = e.querySelector('.y-label.yotpo-user-title');

        e.setAttribute('role', 'tooltip');
        e.removeAttribute('aria-level');

        if (text) {
          text.removeAttribute('role');
          text.removeAttribute('aria-describedby');
        }

      });

      navigation.forEach(e => {
        const menu = e.querySelector('[role="menu"]');

        if (menu) {
          menu.removeAttribute('role');
        }
      });
    }

    function event () {
      const config = { attributes: false, childList: true, subtree: true };

      new MutationObserver(action).observe(target, config);
    }

    action();
    event();
  });

  pollFor('#shopify-section-footer', () => {
    function action () {
      const elements = document.querySelectorAll('noscript');
      log('noscript', elements);

      elements.forEach(element => {
        element.remove();
      });
    }

    setTimeout(action, 1e3);
  });

  pollFor('#shopify-block-583c5cf8-17be-41cf-9fe7-c65bd4cfcad6 a', element => {
    document.querySelector('#shopify-block-583c5cf8-17be-41cf-9fe7-c65bd4cfcad6 a').removeAttribute('href');
  });
}

document.addEventListener('DOMContentLoaded', mainAccessibility, false);
